export default __webpack_public_path__ + "static/bacteria-b42cb70bfe5f318a3b102f83248adfb2.svg";